import { render } from "./VxServices.vue?vue&type=template&id=930e9396"
import script from "./VxServices.vue?vue&type=script&lang=js"
export * from "./VxServices.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__